import { defineMessages } from 'react-intl';

export default defineMessages({
    customerDetails: {
        id: 'ml.quoteandbind.pup.wizard.step.Customer Details',
        defaultMessage: 'Customer Details'
    },
    infoWillNotBeSaved: {
        id: 'ml.quoteandbind.pa.wizard.infoWillNotBeSaved',
        defaultMessage: 'The information you have entered will not be saved'
    },
    underlyingPolicies: {
        id: 'ml.quoteandbind.pup.wizard.step.Underlying Policies',
        defaultMessage: 'Underlying Policies'
    },
    anErrorOccurred: {
        id: 'quoteandbind.pup.wizard.error.cancel',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.pup.wizard.error.cancel.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'quoteandbind.pup.wizard.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.pup.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    },
    generalInfo: {
        id: 'ml.quoteandbind.pup.wizard.General Info',
        defaultMessage: 'General Info'
    },
    exposures: {
        id: 'ml.quoteandbind.pup.wizard.Exposures',
        defaultMessage: 'Exposures'
    },
    purchase: {
        id: 'ml.quoteandbind.pup.wizard.Purchase',
        defaultMessage: 'Purchase'
    }
});